import { ComboBox, type TFormMethods } from "@fluidattacks/design";
import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import type { IFormValues } from "..";

interface IProjectSelectProps {
  readonly onChange: (projectName: string) => void;
  readonly projectNames: string[];
  control: TFormMethods<IFormValues>["control"];
  setValue: TFormMethods<IFormValues>["setValue"];
  trigger: TFormMethods<IFormValues>["trigger"];
}

const ProjectSelect: React.FC<IProjectSelectProps> = ({
  onChange,
  projectNames,
  control,
  setValue,
  trigger,
}): React.JSX.Element => {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (value: string): void => {
      setValue("assigneeId", "");
      void trigger("assigneeId");
      onChange(value);
    },
    [onChange, setValue, trigger],
  );

  return (
    <ComboBox
      control={control}
      items={projectNames.map(
        (projectName): { name: string; value: string } => {
          return { name: projectName, value: projectName };
        },
      )}
      label={t("integrations.gitlab.config.project.label")}
      name={"gitlabProject"}
      onChange={handleChange}
      placeholder={t("integrations.gitlab.config.project.placeholder")}
      required={true}
    />
  );
};

export { ProjectSelect };
